import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 72 72"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("mask", {
  id: "i-1937901983__a",
  width: "72",
  height: "72",
  x: "0",
  y: "0",
  maskUnits: "userSpaceOnUse",
  style: {"mask-type":"alpha"}
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#D9D9D9",
    d: "M0 0h72v72H0z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { mask: "url(#i-1937901983__a)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M51 24.161 18.242 56.92c-.415.416-.937.628-1.566.638a2.121 2.121 0 0 1-1.595-.638 2.152 2.152 0 0 1-.652-1.58c0-.62.217-1.147.652-1.581L47.839 21H29.25c-.637 0-1.172-.216-1.604-.647-.43-.432-.646-.966-.646-1.604 0-.638.215-1.172.646-1.602.432-.431.966-.647 1.604-.647h23.538c.769 0 1.413.26 1.932.78.52.52.78 1.163.78 1.932V42.75c0 .638-.216 1.172-.647 1.603-.432.431-.966.647-1.604.647-.638 0-1.172-.215-1.602-.647-.431-.431-.647-.965-.647-1.603V24.161Z" })
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "more"}) } }